export default __webpack_public_path__ + "static/2285-caf0e4db9c3e898facc9f016345b9a20.gif";